import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/system/Box";
import Typography from "@mui/material/Typography";
import { nullCheck } from "../../../../utils/dataHelpers";

export default function ShotClockTimerCell({ row, column }) {
  let timeRemaining = "";
  const defaultTime = "07:00"; 
  const sequence = nullCheck(row, null, "original", "sequence");

  if (sequence == 1) {
    timeRemaining = nullCheck(column, null, "timeRemaining");
  } else {
    timeRemaining = defaultTime;
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Typography variant="body1" color="black_solid.80">
        {timeRemaining}
      </Typography>
    </Box>
  );
}

ShotClockTimerCell.propTypes = {
  row: PropTypes.object,
  column: PropTypes.object,
};